import styled from 'styled-components';

import MuiInputLabel from '@material-ui/core/InputLabel';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiFormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

export const MuiSelect = styled(Select)`
  && {
    border-radius: 8px;
    .MuiInputBase-input {
      background: #fff;
      color: #212121;
      padding: 11.5px 14px;

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        fieldset {
          border-color: #5cabdd;
        }
      }
    }

    .MuiSelect-icon {
      right: 12px;
      top: calc(50% - 9px);
    }

    fieldset {
      border-color: #b5b5c3;
      > legend > span {
        padding-right: 10px;
      }
    }

    &.Mui-disabled {
      .MuiInputBase-input {
        background: #eaedf2;
        border-radius: 8px;
        color: ${(props) => props.theme.colors.nero};
        -webkit-text-fill-color: ${(props) => props.theme.colors.nero};
      }
      fieldset {
        border-color: #ebedf3;
      }
    }

    &:not(.Mui-disabled):hover,
    &:not(.Mui-disabled):focus {
      fieldset {
        border-color: #5cabdd;
      }
    }
    &.Mui-focused {
      fieldset {
        border-color: #5cabdd;
        border-width: 1px;
      }
    }
  }
`;
export const FormControl = styled(MuiFormControl)``;
export const MenuItem = styled(MuiMenuItem)`
  && {
    font-size: 14px;
    line-height: 19px;
    color: #68686a;
    :active,
    :hover {
      background-color: ${(props) => props.theme.colors.malibu01};
    }
  }
`;
export const InputLabel = styled(MuiInputLabel)`
  && {
    font-size: 14px;
    line-height: 19px;
    color: #68686a;
    top: -5px;
    &[data-shrink='true'] {
      top: 3px;
    }

    &.Mui-focused {
      color: #68686a;
    }

    &.Mui-disabled {
      color: ${(props) => props.theme.colors.nero};
    }
  }
`;
